<form (ngSubmit)="save()" [formGroup]="form">
	<div [alarisLoading]="ratesService.loading$">
		<div class="edit-panel-header">
			<alaris-icon name="icon-add-contact"></alaris-icon>
			{{ rate.id ? ("rates.edit" | translate) : ("rates.add" | translate) }}
		</div>
		<div [alarisFade]="'vertical'" class="form-group panel-content">
			<alaris-select2
				[label]="'rates.currency_name' | translate"
				[displayWith]="displayWithName.bind(this)"
				[readonly]="!!rate.id"
				formControlName="currencyId"
				mode="tag"
				[errors]="errors"
			>
				@for (currency of currenciesService.list; track currency) {
					@if (!currency.isSystemCurrency) {
						<alaris-options2 [value]="currency.id">
							{{ currency.name }}
						</alaris-options2>
					}
				}
			</alaris-select2>

			<alaris-input-date
				[errors]="errors"
				[toLocalDate]="true"
				[formControl]="form.controls.startDate"
				label="{{ 'rates.start_date' | translate }}"
			>
			</alaris-input-date>

			<alaris-input-number formControlName="rate" [errors]="errors" [allowNegativeNumbers]="false">
				{{ "rates.rate" | translate }}
			</alaris-input-number>

			<button (click)="reset()" alaris-button bType="secondary" class="reset-button" size="lg" type="button">
				<alaris-icon name="icon-refresh-clock-wise"></alaris-icon>
				{{ "gl.reset" | translate }}
			</button>
		</div>
		<div class="edit-panel-footer">
			<button
				[disabled]="form.invalid || !form.dirty || editForbidden()"
				alaris-button
				bType="primary"
				size="lg"
				type="submit"
			>
				<alaris-icon class="in-primary" name="icon-success"></alaris-icon>
				{{ "gl.submit" | translate }}
			</button>
			<button (click)="close()" alaris-button bType="outline" size="lg" type="button">
				{{ "actions.close" | translate }}
			</button>
		</div>
	</div>
</form>
